import React from 'react';
import { AddSectionButton } from '../AddSectionButton';
import { Section, SectionData } from '../Section';
import { SectionListHeader } from '../SectionListHeader';
import { FieldConfig } from '../Field';
import { Action } from '../dispatcher';
import { AlertMessage } from '../../../../components/AlertMessage';

interface PropTypes {
  fieldConfigs: FieldConfig[];
  singleTypeSections: boolean;
  sections: SectionData[];
  dispatch?: React.Dispatch<Action>;
  readOnly?: boolean;
}

export function SectionList(props: PropTypes) {
  function handleAddSection() {
    props.dispatch({ type: 'section_add' });
  }

  return (
    <div className='py-4'>
      <SectionListHeader
        onAddSection={handleAddSection}
        readOnly={props.readOnly}
      />
      <div className='py-4 vstack gap-4'>
        {props.sections.map((section, i) => (
          <Section
            key={section.cId}
            fieldConfig={props.fieldConfigs}
            singleTypeSections={props.singleTypeSections}
            data={section}
            dispatch={props.dispatch}
            removeDisabled={props.sections.length === 1}
            upDisabled={i === 0}
            downDisabled={i === props.sections.length - 1}
            readOnly={props.readOnly}
          />
        ))}
      </div>
      {!props.readOnly && (
        <div className='d-flex justify-content-center'>
          <AddSectionButton onClick={handleAddSection} />
        </div>
      )}
      <InterviewRatingAlert />
    </div>
  );
}

function InterviewRatingAlert() {
  return (
    <div className='d-flex justify-content-center'>
      <AlertMessage
        icon={{ name: 'bi-info-circle' }}
        text='Interview rating is added to all scorecards by default! The rating includes: Definitely Not, No, Yes and Definitely Yes.'
        hasOverlay={false}
        className='mt-6 bg-light-info py-2 px-3 rounded align-self-start fs-5'
      />
    </div>
  );
}
